export default {
  loadFailed: 'Failed to load parameters',
  pointerSpeed: {
    titleWindows: 'Windows Pointer Speed',
    titleMac: 'Tracking Speed',
  },
  liftoffHeight: {
    title: 'Liftoff Distance',
  },
  sensorAngle: {
    title: 'Sensor Angle',
  },
  wheelSpeed: {
    title: 'Windows Scroll Speed',
    wheelLinesTitle: 'Scroll the entire row',
    wheelLinesDesc: 'Scroll by the specified number of rows',
    wheelPageTitle: 'Scroll the entire page',
    wheelPageDesc: 'Scroll the entire page at once',
  },
  reportRate: {
    title: 'Report Rate',
  },
  keyDebounce: {
    title: 'Key Debounce Delay (ms)',
    press: 'Press Debounce',
    release: 'Release Debounce',
    tip: 'Short debounce delays may pose a risk of automatic triggering.',
  },
  glassTracking: {
    title: 'Glass Tracking',
    description:
      'Improves 3950 engine mouse stability on glass surfaces. Recommended to turn off on non-glass surfaces.',
  },
  switchGroup: {
    motionSync: {
      title: 'Motion Sync',
      description:
        'Algorithmically corrects mouse movement trajectory to improve tracking stability',
    },
    lineCorrection: {
      title: 'Line Correction',
      description:
        'Corrects trajectory deviation during straight-line mouse movement, eliminating jitter',
    },
    waveCorrection: {
      title: 'Wave Correction',
      description: 'Adjusts wave-like jitter at high DPI, smoothing movement speed control',
    },
  },
}
